import { Container, Nav, Navbar } from "react-bootstrap";
import navigationItems, { HOME_PATH } from "./NavigationItems";

import BrandLogo from "../../../assets/images/logos/newspace-logo.png";
import { Link } from "gatsby";
import React from "react";

const Navigation = ({ page }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isHome, setIsHome] = React.useState(true);

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      setIsHome(window.location.pathname.length < 2);
    }
  }, []);

  return (
    <section
      style={{
        background: isHome ? "transparent" : "rgb(255,255,255,0.7)",
        paddingBottom: "42px",
        //position: [SHARING].includes(page) ? undefined : "fixed",
        width: "100%",
        zIndex: 8,
      }}
    >
      <div
        id="nav-icon"
        className={isOpen ? "open" : undefined}
        onClick={() => setIsOpen(!isOpen)}
        aria-hidden="true"
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <Container>
        <Navbar.Brand>
          {!isHome && (
            <Link to={HOME_PATH}>
              <img
                className="brand-logo"
                src={BrandLogo}
                alt="new.space"
                style={{ paddingTop: "48px" }}
              />
            </Link>
          )}
        </Navbar.Brand>
        <Nav
          className="navbar-nav"
          style={{ transform: isOpen ? "scale(1)" : "scale(0)" }}
        >
          {navigationItems.map((navItem, idx) => (
            <Nav.Item key={idx}>
              <Link
                to={navItem.url}
                activeClassName="active-item"
                title={navItem.title}
              >
                {navItem.page}
              </Link>
            </Nav.Item>
          ))}
        </Nav>
      </Container>
    </section>
  );
};

export default Navigation;
